import { deletableTypes } from "data/variables";
import styled from "styled-components";
import Button from "../general/buttonv2";

export const StyledHeader = styled.div`
  width: 100%;
  padding: 2rem 0;
  position: relative;
  background-color: var(--text-color);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: var(--text-color);
  @media screen and (max-width: 992px) {
    height: auto;
    padding-bottom: 2rem;
  }
  * {
    color: ${(props) => props["data-dark"] && "var(--text-color)"};
  }
`;

const StyledTitleAboveHero = styled.div`
  font-size: 0.75rem;
  padding: 0 0 2rem 0;
  text-decoration: none;
  color: var(--text-color);
  font-weight: 700;
  font-size: 19px;
  display: flex;
  align-items: center;
  > svg {
    height: 14px;
    width: auto;
    fill: var(--text-color);
    margin-right: 16px;
  }
  @media screen and (max-width: 768px) {
    padding: 2rem 0;
  }
  &:hover,
  &:focus,
  &:active {
    text-decoration: none;
  }
`;
const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;
const StyledContainer = styled.div`
  max-width: 1280px;
  width: calc(100% - 4rem);
  display: flex;
  padding: 4rem 0;
  gap: 2rem;
  @media screen and (max-width: 992px) {
    flex-direction: column;
  }
`;
const StyledBlock = styled.div`
  display: flex;
  flex-direction: column;
`;
const StyledBorderContainer = styled.div`
  position: relative;
  margin-bottom: 1rem;
`;
const Video = ({ className, src }) => (
  <video playsInline autoPlay muted loop className={className}>
    <source src={src} type="video/mp4" />
  </video>
);

const StyledVideo = styled(Video)`
  max-width: 100%;
  width: 840px;
  height: auto;
  object-fit: cover;
  position: relative;
  background: transparent url(/images/placeholder.png) no-repeat 0 0;
  background-size: cover;
`;

const Header = ({ dark, singleData }) => {
  const headerTitle = `${singleData.uniqueh1}`;
  return (
    <StyledWrapper data-dark={dark}>
      <StyledContainer>
        <StyledBlock style={{ flex: 3 }}>
          <h1 className="hero__title" style={{ color: "var(--text-color)" }}>
            {headerTitle}
          </h1>
          <p style={{ marginBottom: "2rem" }}>{singleData.description}</p>
          <Button to="/download" buttonPrimary={true}>
            Download Redact
          </Button>
        </StyledBlock>
        <StyledBlock style={{ flex: 2 }}>
          {singleData?.video && <StyledVideo src={singleData.video} />}
        </StyledBlock>
      </StyledContainer>
    </StyledWrapper>
  );
};

export default Header;
